var eses = {
	"price-platform": {
	unit: "unidad",
	"setup-fee": "Coste de configuración",
	"includes-setup-fee": "Incluye coste de configuración",
	"no-setup-fee": "Configuración gratis",
	"no-minimum-quantity": {
		value: "Sin cantidad mínima",
		_context: "Max length 25"
	},
	"minimum-quantity": {
		value: "Cantidad mínima {{0}}",
		_context: "Max length 25"
	},
	"minimum-quantity-units": "Mínimo {{0}} unidades",
	"volume-discount": {
		value: "{{0}} % descuento por volumen",
		length: 50,
		_context: "Do not use 'de' in Spanish => it should be {{0}} % descuento por volumen"
	},
	"volume-discount-sale": "{{0}}% de descuento por volumen + ofertas",
	"price-suffix": {
		total: "total"
	},
	"delivery-not-included": "Envío no incluido",
	"tariff-surcharge": "Tariffs surcharge may apply",
	"tariff-surcharge-popover": "This product is affected by new tariffs on goods from China, and a surcharge may be applied during checkout. If you’d like help finding other options, call (866) 507-7454.",
	"tariff-surcharge-aria-label": "Surcharge Details Popover"
}
};

export { eses as default };
//# sourceMappingURL=src-localization-texts-es-es.json.js.map
